'use strict'
document.addEventListener('DOMContentLoaded', function() {
  let article_body = document.getElementById("article_body")
  let show_form_body = document.getElementById("show_form_body")

  if(show_form_body) {
    ClassicEditor
    .create( document.querySelector( '#show_form_body' ), {

    } )
    .then( editor => {
      editor.isReadOnly = true
      window.editor = editor;
    } )
    .catch( err => {
      console.error( err.stack );
    } );
  }

  setEventListener()

  // ToucEvent
  let target = document.getElementById("footer_navbar")
  let articleDetail = document.getElementById("article_detail")
  let navbarCollapse = document.getElementById("navbarCollapse")

  let startX
  let startY
  let moveX
  let moveY
  let dist = 30
  let distY = 60
  if(target) {
    target.addEventListener('touchstart', function(e) {
      startX = e.touches[0].pageX
      startY = e.touches[0].pageY
    })
    target.addEventListener('touchmove', function(e) {
      e.preventDefault()
      moveX = e.changedTouches[0].pageX
      moveY = e.changedTouches[0].pageY
    })
    target.addEventListener('touchend', function(e) {
      var index
      if(moveX == undefined || moveX == 0){
        // スワイプなし時の処理
      }
      else if (startX > moveX && startX > moveX + dist) {
        // 右から左にスワイプした時の処理
        if(articleDetail) {
          Article.next()
        }
      }
      else if (startX < moveX && startX + dist < moveX) {
        // 左から右にスワイプした時の処理
        if(articleDetail) {
          Article.prev()
        }
      }
      else if (startY < moveY && startY + distY < moveY) {
        // 上から下にスワイプした時の処理
        if(navbarCollapse){
          if (navbarCollapse.classList.contains("show")) {
            navbarCollapse.classList.remove("show")
          }
        }
      }
      else {
      }

      startX = 0
      startY = 0
      moveX = 0
      moveY = 0
    })
  }
})
function setEventListener(){
  var btnCreateButtons = document.querySelectorAll(".btn-create");
  btnCreateButtons.forEach(function(target) {
    target.addEventListener('click', function(e) {
      Article.create(e.currentTarget)
    })
  })
}
var Article = {
  init: function(){
    serviceBaseUrl = location.origin
    articleUrl = serviceBaseUrl + "/front/articles.json"
    articleSearchUrl = serviceBaseUrl + "/front/articles/search.json"
    articlesKey = "articles"
    articleKey = "article"
  },
  createRequest: function(url, method, data){
    var request = new Request(url, {
      method: method,
      mode: 'cors',
      credentials: 'same-origin',
      headers: new Headers({
        "Content-Type": "application/json",
      }),
      body: data,
      cache: 'no-cache'
    })
    return request
  },
  show: function(info) {
    this.init()
  },
  prev: function() {
    location.href = location.pathname + "/prev"
  },
  next: function() {
    location.href = location.pathname + "/next"
  },
  setMessage: function(messageText) {
    console
    if(flash_messages){
      flash_messages.innerHTML = ""
      var div = document.createElement("div")
      div.setAttribute("class", "alert alert-danger alert-dismissable flash-message")
      div.innerText = messageText
      var button = document.createElement("button")
      button.setAttribute("type", "button")
      button.setAttribute("class", "close")
      button.setAttribute("data-dismiss", "alert")
      button.setAttribute("aria-hidden", "true")
      button.innerText = "x"
      div.appendChild(button)
      flash_messages.appendChild(div)
    }
  }
}
